import { Link } from "react-router-dom";
import { Home, Building2, Truck, Sparkles, RefreshCw, Store, ArrowUpRight } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function CustomerCards() {
    const { t } = useT();
    const cards = [
        { to: "/homeowners", icon: Home, title: t("nav_homeowners"), blurb: "Compare plans for the house you own." },
        { to: "/renters", icon: Building2, title: t("nav_renters"), blurb: "Apartments, condos, and rental homes." },
        { to: "/moving", icon: Truck, title: t("nav_moving"), blurb: "Get service connected before move-in." },
        { to: "/first-time", icon: Sparkles, title: "First-time customers", blurb: "Setting up your very first account." },
        { to: "/existing", icon: RefreshCw, title: "Existing customers", blurb: "Review your current plan or renew." },
        { to: "/business", icon: Store, title: t("nav_business"), blurb: "Restaurants, shops, offices, warehouses." },
    ];
    return (
        <section id="who-you-are" className="max-w-7xl mx-auto px-4 sm:px-6 py-14" data-testid="customer-cards">
            <div className="flex items-end justify-between flex-wrap gap-4">
                <div>
                    <span className="chip">{t("cc_chip")}</span>
                    <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight text-white">
                        {t("cc_title")}
                    </h2>
                    <p className="text-slate-400 mt-2 max-w-2xl">
                        We tailor the questions and the follow-up so you only spend 60 seconds on
                        this — not an hour on hold.
                    </p>
                </div>
            </div>
            <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {cards.map((c, i) => (
                    <Link
                        to={c.to}
                        key={c.to}
                        data-testid={`customer-card-${c.to.slice(1)}`}
                        className="card-surface p-6 reveal group"
                        style={{ animationDelay: `${i * 60}ms` }}
                    >
                        <div className="flex items-start justify-between">
                            <span className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-emerald-500/15 border border-emerald-500/35 text-emerald-300">
                                <c.icon className="w-5 h-5" />
                            </span>
                            <ArrowUpRight className="w-5 h-5 text-slate-500 group-hover:text-emerald-300 transition" />
                        </div>
                        <h3 className="mt-4 text-xl font-semibold text-white">{c.title}</h3>
                        <p className="text-sm text-slate-400 mt-1">{c.blurb}</p>
                    </Link>
                ))}
            </div>
        </section>
    );
}
